import { useEffect, useState } from 'react';

/**
 * true mientras la media query coincida. Para decidir qué montar con el MISMO
 * corte que usa el CSS: window.innerWidth es entero y una media query no, así
 * que con zoom (899.5px) ambos podían discrepar.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};
